import React from "react";
import { Tooltip } from "../../../../../components/tooltip/tooltip";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import Icon from "../../../../../components/icons/icon/icon";
import IconInfo from "../../../../../components/icons/icon-info/icon-info";
import "./column-title-with-tooltip.scss";

interface IProps {
    title: string;
    tooltipContent: string;
}

const ColumnTitleWithTooltip: React.FC<IProps> = ({ title, tooltipContent }) => {
    return (
        <div className="shipments-page-column-title-with-tooltip-container">
            {title}
            <Tooltip 
                content={
                    <div className="shipments-page-column-title-tooltip-container">
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            {tooltipContent}
                        </FontBody2>
                    </div>
                }
            >
                <Icon Component={IconInfo} />
            </Tooltip>
        </div>
    );
};

export default ColumnTitleWithTooltip; 